module.exports = __webpack_public_path__ + "static/media/climbing_view_768.05121bdc.webp";